import { render, staticRenderFns } from "./WithdrawByPortfolio.vue?vue&type=template&id=752d2d86&scoped=true"
import script from "./WithdrawByPortfolio.vue?vue&type=script&setup=true&lang=ts"
export * from "./WithdrawByPortfolio.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WithdrawByPortfolio.vue?vue&type=style&index=0&id=752d2d86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752d2d86",
  null
  
)

export default component.exports